import React, { useContext } from "react";

import { LinkedApplicationContext, ProjectList } from "@swegon/sds-core";

const Projects = () => {
    const { isLinkedApplication } = useContext(LinkedApplicationContext);

    if (isLinkedApplication) {
        return null;
    }

    return <ProjectList />;
};

export default Projects;
